export default "__VITE_ASSET__BbyY$Dz7__"